// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".createdAtColValue_3WvbznwTDRJqiVAvafLAgH{direction:ltr;text-align:center}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/cafeDiscounts/List/styles.scss"],"names":[],"mappings":"AAAA,0CACE,aAAc,CACd,iBAAkB","file":"styles.scss","sourcesContent":[":local(.createdAtColValue) {\n  direction: ltr;\n  text-align: center;\n}\n"]}]);
// Exports
exports.locals = {
	"createdAtColValue": "createdAtColValue_3WvbznwTDRJqiVAvafLAgH"
};
module.exports = exports;
